// eslint-disable-next-line max-classes-per-file
const events = require('events-mixin');
const domify = require('domify');
const EventEmitter = require('events');
const q = require('queried');
const ajax = require('component-ajax');

const cookie = require('cookie-cutter');
const {
  PartnersSlider,
} = require('./partners');

const decorations = `
  <span class="nyt-decor nyt-decor1"></span>
  <span class="nyt-decor nyt-decor2"></span>
  <span class="nyt-decor nyt-decor3"></span>
  <span class="nyt-decor nyt-decor4"></span>
  <span class="nyt-decor nyt-decor5"></span>
`;

class Screen extends EventEmitter {}

class FirstScreen extends Screen {
  render() {
    const element = domify(`
            <div class="nyt-slide nyt-slide--visible">
                ${decorations}
                <div class="nyt-metaHeader">
                    <div class="nyt-questionImage nyt-questionImage--metaSlide">
                        <div class="nyt-questionTitle">
                            <div class="nyt-questionTitleContent">
                                Тренды 2к16: ты в теме или в норке?
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nyt-metaBody">
                    <div class="nyt-metaBodyText">
                        Настало время узнать, чем&nbsp;запомнился&nbsp;2016 именно&nbsp;тебе.
                        Успел&nbsp;ли ты&nbsp;проникнуться&nbsp;духом главных&nbsp;трендов уходящего&nbsp;года?
                        Наш новогодний тест расставит все точки&nbsp;над&nbsp;i.
                        Проверь&nbsp;себя и&nbsp;получи праздничные&nbsp;подарки от&nbsp;KudaGo!
                    </div>
                    <button class="button nyt-buttonNext">
                        Начать тест
                    </button>
                </div>
            </div>
        `);

    this.bindEvents(element);
    return element;
  }

  bindEvents(element) {
    this.events = events(element, this);
    this.events.bind({
      'click .nyt-buttonNext': () => this.emit('next'),
    });
  }
}

class GameScreen extends Screen {
  constructor({ question, step, questionsLength }) {
    super();

    this.question = question;
    this.step = step;
    this.questionsLength = questionsLength;

    this.element = this.createElement();
    this.bindEvents(this.element);
  }

  createElement() {
    const question = this.question.asObject();
    const answers = question.answers.map((a, index) => `
            <label class="nyt-answer">
                <input type="radio" name="answer" value="${index}" class="nyt-answerRadio">
                ${a}
            </label>
        `).join('');

    const element = `
            <div class="nyt-slide">
               ${decorations}
                <div class="nyt-questionImage" style="background-image: url(${question.image})">
                    <div class="nyt-questionTitle">
                        <div class="nyt-questionTitleContent">
                            ${question.question}
                        </div>
                    </div>
                    <div class="nyt-status">
                        ${this.step + 1}/${this.questionsLength}
                    </div>
                </div>
                <form class="nyt-questionBody">
                    ${answers}
                    <button class="button nyt-buttonNext" disabled>
                        Дальше
                    </button>
                    <div class="nyt-errorText"></div>
                </form>
            </div>
        `;

    return domify(element);
  }

  render() {
    // fade in
    setImmediate(() => {
      this.element.classList.add('nyt-slide--visible');
    });

    return this.element;
  }

  bindEvents(element) {
    this.events = events(element, this);
    this.events.bind({
      'click .nyt-buttonNext': (e) => {
        e.preventDefault();
        this.emit('next');
      },
      'change [type="radio"]': (e) => {
        const chosen = e.target.value;
        const patch = this.question.getPatch(+chosen);
        this.emit('answerChange', patch);

        const button = q('.button', this.element);
        button.removeAttribute('disabled');
      },
    });
  }

  renderError(errorText) {
    q('.nyt-errorText', this.element).textContent = errorText;
  }

  renderLoadingState() {
    const button = q('.nyt-buttonNext', this.element);
    button.textContent = 'Подождите...';
    button.setAttribute('disabled', 'disabled');
  }

  renderStaticState() {
    const button = q('.nyt-buttonNext', this.element);
    button.textContent = 'Дальше';
    button.removeAttribute('disabled');
  }
}

class LastScreen extends Screen {
  constructor({ title, description, image }) {
    super();

    this.element = q('.nyt-slide--last');

    this.title = title;
    this.description = description;
    this.image = image;

    this.bindEvents(this.element);
  }

  bindEvents(element) {
    this.events = events(element, this);
    this.events.bind({
      'click .nyt-getButton': 'getGift',
      'click .login-link': 'sendLoginMetrics',
    });
  }

  getGift(e) {
    const button = e.target;
    button.setAttribute('disabled', 'disabled');
    button.textContent = 'Подождите...';

    const { ga } = window;
    ga('send', {
      hitType: 'event',
      eventCategory: 'new-year-quiz',
      eventAction: 'get-gift',
    });

    ajax({
      url: '/gifts/send/',
      type: 'POST',
      data: cookie.get('csrftoken'),
      success: () => {
        const markup = q('.nyt-nextText', this.element).innerHTML;
        const content = q('.nyt-metaInfo', this.element);
        content.innerHTML = markup;
      },
    });
  }

  sendLoginMetrics() {
    const { ga } = window;

    ga('send', {
      hitType: 'event',
      eventCategory: 'new-year-quiz',
      eventAction: 'login-or-signup',
    });
  }

  initPartnersSlider() {
    this.partnersContainer = q('.nyt-partners-holder', this.element);
    if (this.partnersContainer) {
      new PartnersSlider(this.partnersContainer);
    }
  }

  render() {
    this.element.removeAttribute('hidden');

    if (this.title) {
      const titleElement = q('.nyt-questionTitleContent', this.element);
      titleElement.textContent = this.title;
    }

    if (this.description) {
      const descriptionElement = q('.nyt-metaBodyText', this.element);
      descriptionElement.textContent = this.description;
    }

    if (this.image) {
      const imageElement = q('.nyt-questionImage', this.element);
      const style = `background-image: url(${this.image}) !important;`;
      imageElement.setAttribute('style', style);
    }

    this.initPartnersSlider();

    setImmediate(() => {
      this.element.classList.add('nyt-slide--visible');
    });

    return this.element;
  }
}

class CollapsedScreen extends Screen {
  constructor() {
    super();
    this.element = this.createElement();
    this.bindEvents(this.element);
  }

  createElement() {
    return domify(`
      <div class="nyt-slide nyt-slide--collapsed">
        <div class="nyt-collapsedTitle">
          Новогодний тест «Тренды 2к16: ты в теме или в норке»
        </div>
        <span class="link nyt-openLastScreen">показать результаты ▾</span>
      </div>
    `);
  }

  render() {
    // fade in
    setImmediate(() => {
      this.element.classList.add('nyt-slide--visible');
    });

    return this.element;
  }

  bindEvents(element) {
    this.events = events(element, this);
    this.events.bind({
      'click .nyt-openLastScreen': (e) => {
        e.preventDefault();
        this.emit('show-last-screen');
      },
    });
  }
}

module.exports = {
  FirstScreen,
  GameScreen,
  LastScreen,
  CollapsedScreen,
};
